import fr from 'facet-rest';
import BaseOverride from 'Overrides/OnboardingStep/BaseOverride';

export default fr.metaOverride({ base: BaseOverride });
